import { createContext, useContext } from "react";
import { useParams } from "react-router-dom";

type AccountPageParams = {
  accountId: string;
  workspaceId?: string;
  objectSlug?: string;
};

/**
 * Context used by the account drawer to provide route-like params
 * without a nested Router.
 */
export const AccountPageParamsContext = createContext<AccountPageParams | null>(null);

/**
 * Drop-in replacement for useParams() in account page components.
 * Checks the drawer context first, falls back to react-router useParams().
 */
const useAccountPageParams = () => {
  const ctx = useContext(AccountPageParamsContext);
  const params = useParams<Record<string, string>>();

  if (ctx) {
    return {
      ...params,
      accountId: ctx.accountId,
      workspaceId: ctx.workspaceId || params.workspaceId,
      objectSlug: ctx.objectSlug || params.objectSlug,
    };
  }

  return params;
};

export default useAccountPageParams;
